import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
const ELFSIGHT_SCRIPT_ID = 'elfsight-platform';
const ELFSIGHT_APP_CLASS = 'elfsight-app-c13dd18b-2e06-4811-bc3c-dfee05772735';

/**
 * Google Bewertungen – eingebunden über das Elfsight-Widget,
 * damit Bewertungen und Sternedurchschnitt automatisch aktuell bleiben.
 */
export function GoogleReviews() {
  const sectionRef = useRef<HTMLElement>(null);

  // Das Elfsight-Skript ist der schwerste externe Baustein der Seite. Es wird
  // deshalb erst geladen, wenn der Bereich in Sichtweite kommt.
  useEffect(() => {
    const loadScript = () => {
      if (document.getElementById(ELFSIGHT_SCRIPT_ID)) return;
      const script = document.createElement('script');
      script.id = ELFSIGHT_SCRIPT_ID;
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.body.appendChild(script);
    };
    const target = sectionRef.current;
    if (!target || typeof IntersectionObserver === 'undefined') {
      loadScript();
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        loadScript();
        observer.disconnect();
      }
    }, {
      rootMargin: '600px'
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} id="google-bewertungen" aria-label="Google Bewertungen" className="w-full px-4 py-10 sm:px-6 sm:py-12" data-id="element-242" data-mp="2ajuuvxsnoo5e">
      <div className="mx-auto mb-8 max-w-3xl text-center" data-id="element-243" data-mp="2fco2ctfieal6">
        <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-white" data-id="element-244" data-mp="21kpusn1g4mr4">
          Testimonials
        </span>
        <div className="relative inline-block" data-id="element-245" data-mp="25inlxves1ix5">
          <Sparkle className="animate-sparkle left-3 top-1 h-5 w-5 sm:-left-9 sm:h-7 sm:w-7" data-id="element-246" data-mp="1rma76u1mnvmd" />
          <Sparkle className="animate-sparkle-fast right-8 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-247" data-mp="1wjabazex2oau" />
          <h2 className="font-display text-gold-3d text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl lg:text-4xl" style={{
          fontSize: "36px"
        }} data-id="element-248" data-mp="2553nv2io8yg">
            Stimmen aus der Academy
          </h2>
        </div>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white sm:text-base" data-id="element-249" data-mp="3phpa7skmtjsg">
          Lies, wie unsere Teilnehmerinnen gestartet sind – und was sich seitdem verändert hat.
        </p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="mx-auto w-full max-w-[1300px]" data-id="element-250" data-mp="l0v95s9nrnh3">
        {/* Skaliert das Widget leicht herunter, damit die Schriftgröße zum Rest der Seite passt. */}
        <div style={{
        zoom: 0.875
      }} data-id="element-251" data-mp="2wtbexkkxh1kl">
          <div className={ELFSIGHT_APP_CLASS} data-elfsight-app-lazy data-id="element-252" data-mp="2wq5p234h5vnt" />
        </div>
      </motion.div>
    </section>;
}